module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Menu-c2ffeeea0839f2e72a8e911bd7dcd9a1.svg";